import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { setting } from '../../../../setting';
import { RestService } from 'app/shared/rest.service';

@Injectable({
  providedIn: 'root'
})
export class RequestBilledFormService {

  constructor(private _http: HttpClient, private _restService: RestService) { }


  getTypeIva(): Observable<any> {
    let headers = new HttpHeaders();

    headers = headers.set('ApiUser', setting.abacoApiUser);
    headers = headers.set('apiKey', setting.abacoApiKey);

    const url = `${setting.apiAbacoUrl}ivaConditions`;

    return this._http.get<any>(url, { headers: headers });
  }

  getConditionIva(): Observable<any> {
    let headers = new HttpHeaders();

    headers = headers.set('ApiUser', setting.abacoApiUser);
    headers = headers.set('apiKey', setting.abacoApiKey);

    const url = `${setting.apiAbacoUrl}arca/catalogs/getReceiverIVACondition`;

    return this._http.get<any>(url, { headers: headers });
  }

  getCurrencies(): Observable<any> {
    let headers = new HttpHeaders();

    headers = headers.set('ApiUser', setting.abacoApiUser);
    headers = headers.set('apiKey', setting.abacoApiKey);

    const url = `${setting.apiAbacoUrl}arca/catalogs/getTiposMonedas`;

    return this._http.get<any>(url, { headers: headers });
  }

  getIvaTypes(): Observable<any> {
    let headers = new HttpHeaders();

    headers = headers.set('ApiUser', setting.abacoApiUser);
    headers = headers.set('apiKey', setting.abacoApiKey);

    const url = `${setting.apiAbacoUrl}arca/catalogs/getTiposIVA`;

    return this._http.get<any>(url, { headers: headers });
  }

  getTourismItems(): Observable<any> {
    let headers = new HttpHeaders();

    headers = headers.set('ApiUser', setting.abacoApiUser);
    headers = headers.set('apiKey', setting.abacoApiKey);

    const url = `${setting.apiAbacoUrl}arca/wsct/catalogs/codigos-item-turismo`;

    return this._http.get<any>(url, { headers: headers });
  }

  getEnterprise(): Observable<any> {
    let headers = new HttpHeaders();

    headers = headers.set('ApiUser', setting.abacoApiUser);
    headers = headers.set('apiKey', setting.abacoApiKey);

    const url = `${setting.apiAbacoUrl}enterprises`;

    return this._http.get<any>(url, { headers: headers });
  }

  getDocType(): Observable<any> {
    let headers = new HttpHeaders();

    headers = headers.set('ApiUser', setting.abacoApiUser);
    headers = headers.set('apiKey', setting.abacoApiKey);

    const url = `${setting.apiAbacoUrl}arca/catalogs/getTiposDocumentos`;

    return this._http.get<any>(url, { headers: headers });
  }

  getReceiptType(): Observable<any> {
    let headers = new HttpHeaders();

    headers = headers.set('ApiUser', setting.abacoApiUser);
    headers = headers.set('apiKey', setting.abacoApiKey);

    const url = `${setting.apiAbacoUrl}arca/catalogs/getTiposComprobantes`;

    return this._http.get<any>(url, { headers: headers });
  }

  getConceptType(): Observable<any> {
    let headers = new HttpHeaders();

    headers = headers.set('ApiUser', setting.abacoApiUser);
    headers = headers.set('apiKey', setting.abacoApiKey);

    const url = `${setting.apiAbacoUrl}arca/catalogs/getTiposConcepto`;

    return this._http.get<any>(url, { headers: headers });
  }

  countriesInvoiceT(): Observable<any> {
        let headers = new HttpHeaders();

    headers = headers.set('ApiUser', setting.abacoApiUser);
    headers = headers.set('apiKey', setting.abacoApiKey);

    const url = `${setting.apiAbacoUrl}arca/wsct/catalogs/paises`;

    return this._http.get<any>(url, { headers: headers });
  }

  getDoctTypeBookingList(): Observable<any> {

    return this._restService.doGet('app', 'documentTypes');
  }

  getClients(): Observable<any> {

    return this._restService.doGet('app', 'clientsAllBilled');

  }

  getCountriesApi(): Observable<any> {

    return this._restService.doGet('api', '/utilities/countries');

  }

  getDestinationsApi(country: string): Observable<any> {

    return this._restService.doGet('api', `/utilities/destinations/${country}`);

  }

  getCitiesApi(destination: number): Observable<any> {

    return this._restService.doGet('api', `/utilities/cities/${destination}`);

  }
}
